import {Redirect, Route, RouteProps} from "react-router-dom";
import {useContext} from "react";
import {UserType} from "../../../services/medicationmanagement/medsUser/MedsUserApi";
import { IdentityContext } from "../../auth/UserIdentity";

export const DoctorRoute = (props:RouteProps)=>{
    let ctx = useContext(IdentityContext);
    
    if (ctx?.userInfo?.userType == UserType.Doctor
        || ctx?.userInfo?.userType == UserType.Dentist
        || ctx?.userInfo?.userType == UserType.GeneralStaffAdmin
        || ctx?.userInfo?.userType == UserType.NursePractitioner
        || ctx?.userInfo?.userType == UserType.Optometrist
        || ctx?.userInfo?.userType == UserType.RegisteredNurse){

            return (
                <Route {...props}>
                    {props.children}
                </Route>
            );
    }
    else{
        return <Redirect to={"/"}/>
    }


}